// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7493 ? "bf5f3635" : chunkId) + "." + {"1959":"4943bc70dce47dbf","7493":"4d0bcb6e1accf2c5"}[chunkId] + ".js";
};